import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable, InjectionToken } from "@angular/core";
import { Observable, tap } from "rxjs";
import { SpinnerService } from "../spinner/spinner.service";

@Injectable()

export class HttpInterceptorService implements HttpInterceptor {

    constructor(
        private spinnerService: SpinnerService
    ) { }



    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.headers.get("skipInterceptor")) return next.handle(req)
        this.spinnerService.setSpinner(true);
        return next.handle(req)
            .pipe(
                tap(event => {
                    if (event instanceof HttpResponse) this.spinnerService.setSpinner(false)
                }, error => {
                    this.spinnerService.setSpinner(false);
                    console.error(error);
                })
            )
    }

}

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');
